/* eslint-disable @typescript-eslint/no-explicit-any */
import { HelpCenterTopic, dashboard } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import AppConstants from 'constants/AppConstants';

export function setExperienceFilter(experienceFilter: any): BaseTockAction {
  return {
    payload: experienceFilter,
    type: AppConstants.UI_SET_EXPERIENCE_FILTER,
  };
}

export function setTemplateFilter(templateFilter: any): BaseTockAction {
  return {
    payload: templateFilter,
    type: AppConstants.UI_SET_TEMPLATE_FILTER,
  };
}

export function setShowArchivedSupplements(supplementGroupId: number, value: any): BaseTockAction {
  return {
    payload: { supplementGroupId, value },
    type: AppConstants.UI_SET_ARCHIVED_SUPPLEMENTS,
  };
}

export function setShowArchivedSupplementGroups(experienceId: number, value: any): BaseTockAction {
  return {
    payload: { experienceId, value },
    type: AppConstants.UI_SET_ARCHIVED_SUPPLEMENT_GROUPS,
  };
}

export function openSupportDrawer(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_SUPPORT_DRAWER,
  };
}

export function closeSupportDrawer(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_SUPPORT_DRAWER,
  };
}

export function openBusinessSwitcherModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_BUSINESS_SWITCHER_MODAL,
  };
}

export function closeBusinessSwitcherModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_BUSINESS_SWITCHER_MODAL,
  };
}

export function openCheckinDateSwitcherModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_CHECKIN_DATE_SWITCHER_MODAL,
  };
}

export function closeCheckinDateSwitcherModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_CHECKIN_DATE_SWITCHER_MODAL,
  };
}

export function openDeliveryDateSwitcherModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_DELIVERY_DATE_SWITCHER_MODAL,
  };
}

export function closeDeliveryDateSwitcherModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_DELIVERY_DATE_SWITCHER_MODAL,
  };
}

export function openDeviceStatusModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_DEVICE_STATUS_MODAL,
  };
}

export function closeDeviceStatusModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_DEVICE_STATUS_MODAL,
  };
}

export function openReleasesModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_RELEASES_MODAL,
  };
}

export function closeReleasesModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_RELEASES_MODAL,
  };
}

export function closeUpcomingChangesModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_UPCOMING_CHANGES_MODAL,
  };
}

export function openUpcomingChangesModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_UPCOMING_CHANGES_MODAL,
  };
}

export function openGlobalSearchModal(): BaseTockAction {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_GLOBAL_SEARCH_MODAL,
  };
}

export function closeGlobalSearchModal(): BaseTockAction {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_GLOBAL_SEARCH_MODAL,
  };
}

export function openHelpCenterModal() {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_HELP_CENTER_MODAL,
  };
}

export function closeHelpCenterModal() {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_HELP_CENTER_MODAL,
  };
}

export function setHelpCenterTopic(selectedTopic?: HelpCenterTopic) {
  return {
    payload: selectedTopic,
    type: AppConstants.UI_SET_HELP_CENTER_TOPIC,
  };
}

export function openPacingPanel() {
  return {
    type: AppConstants.UI_PACING_PANEL_SHOW,
  };
}

export function changePacingPanelTab(tab: StoreType['ui']['pacingPanelTab']) {
  return {
    type: AppConstants.UI_PACING_PANEL_TAB_UPDATE,
    payload: tab,
  };
}

export function closePacingPanel() {
  return {
    type: AppConstants.UI_PACING_PANEL_HIDE,
  };
}

export function openClearTemplatesModal() {
  return {
    payload: true,
    type: AppConstants.UI_TOGGLE_CLEAR_TEMPLATES_MODAL,
  };
}

export function closeClearTemplatesModal() {
  return {
    payload: false,
    type: AppConstants.UI_TOGGLE_CLEAR_TEMPLATES_MODAL,
  };
}

export function openWaitlistReportRowModal(
  waitlistReportRow?: dashboard.WaitlistReportRow
): BaseTockAction {
  return {
    payload: {
      isVisible: true,
      waitlistReportRow,
    },
    type: AppConstants.UI_TOGGLE_WAITLIST_REPORT_ROW_MODAL,
  };
}

export function closeWaitlistReportRowModal(): BaseTockAction {
  return {
    payload: {
      isVisible: false,
      waitlistReportRow: undefined,
    },
    type: AppConstants.UI_TOGGLE_WAITLIST_REPORT_ROW_MODAL,
  };
}

export function openSelfOnboardingHelp(): BaseTockAction {
  return {
    type: AppConstants.UI_SELF_ONBOARDING_HELP_OPEN,
  };
}

export function closeSelfOnboardingHelp(): BaseTockAction {
  return {
    type: AppConstants.UI_SELF_ONBOARDING_HELP_CLOSE,
  };
}
